/**
 * App-wide date/time: "24 Jun 2026, 18:10" (24-hour clock, en-IN).
 * @param {Date|string|number|null|undefined} value
 * @param {string} [empty="—"]
 */
export function formatDateTime(value, empty = "—") {
  if (value == null || value === "") return empty;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const datePart = d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const timePart = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${datePart}, ${timePart}`;
}

export const formatTripDateTime = formatDateTime;
